export const initialState = {
    pictures: [],
  };